<template>
  <div class="wrap search-wrap flex-column">
    <topLink></topLink>
    <!-- 搜索框 -->
    <div class="input-box">
      <input class="serarch-input" type="text" name="" placeholder="搜索商品" v-model="keyWord" @focus='focusinput()' @blur="blurinput()"  id='input'>
      <span class="search-btn" @click="filter()">搜索</span>
      <span class="search-btn multiple" @click="rightPopup=true">筛选</span>
    </div>
    <!-- 筛选条件 -->
    <!-- <div class="search-condition">
      <mu-flat-button label="综合" @click="seoRanking"  :class="{'primary':seo}"/>
      <mu-flat-button label="销量" class="sales"  :class="{activeAsc:asc=='asc',activeDesc:asc=='desc'}" @click="select()"/>
      <mu-flat-button label="筛选" class="multiple" @click="rightPopup=true"/>
    </div> -->
    <mu-infinite-scroll :loading="load" loadingText="拼命加载中" class="load" v-if="load"/>
     
    <div ref="listBox" class="box flex-item " v-show="!load">
<!--       <div class="banner-img" @click="linkFn(adver.linkType,adver.linkTarget)">
        <imgs :height="240" :imagePath="adver && adver.imagePath && adver.imagePath.imagePath"></imgs>
      </div> -->
      <div class="bottom">
        <div class="left-advertise square" v-for="item in goodsList">
          <div class="img" @click="gotoSunhomeDetail(item.shareId)">
            <imgs :titleText="item.shareContent" :imagePath="item && item.imagePath && item.imagePath.imagePath"></imgs>
            <p class="userName ellipsis">来自 {{item.shareBy}} 的评价</p>
            <p class="style-box flex-row">
              <span class="style ellipsis flex-item"><template v-for='sub in item.tags'>{{sub.linkName}}&nbsp;</template></span>
              <span class="price ellipsis" v-if="item.totalPrice > 0">{{item.totalPrice}}元</span>
            </p>
          </div>
          
        </div>
        <mu-infinite-scroll :scroller="scroller" :loading="loading" loadingText="" @load="loadMore" />
      </div>
    <!--   <div class="product-lists">
        <div class="product-list square" v-for="gooditem in goodsList"  @click="scanDetail(gooditem.storeId,gooditem.goodsId,gooditem.skuId)">
          <div class="img-box">
            <imgs :width="522" :height="522" :imagePath="gooditem && gooditem.imagePath && gooditem.imagePath.imagePath" :titleText="gooditem.goodsName" :moneyText="gooditem.goodsPrice || ''"></imgs>
          </div>
        </div>
          <mu-infinite-scroll :scroller="scroller" :loading="loading" loadingText="" @load="loadMore" />
      </div> -->
      <p class="none-goods" v-if="(lastPageNo == pageNo && !load) || (total ==0 && !load) ">没有更多商品啦~</p>
    </div>
    
    <!-- 综合排序、销量排序选项 -->
    <div class="colligate-select" v-if="isColligate">
      <div class="radio">
        <div class="radio-item" :class="{active:asc=='asc'}" @click="sale('asc')">销量从低到高</div>
        <div class="radio-item" :class="{active:asc=='desc'}" @click="sale('desc')">销量从高到低</div>
      </div>
    </div>
    <!-- 筛选 -->
    <mu-popup position="right" popupClass="filter-popup" :open="rightPopup" @close="rightPopup=false">
      <div class="flex-column">
          <div class="filter-header">
            <span class="arrow" @click="rightPopup=false"></span>
            <samp class="">筛选</samp>
          </div>
          <div class="flex-item">
            <!-- <div class="item">
              <span class="label active">有货</span>
              <span class="label">特惠</span>
              <span class="label">促销热品</span>
            </div> -->
            <!-- <div class="item" >
              <p class="filter-list-header">价格区间(元)</p>
              <div class="list-item spread">
                <input class="label" placeholder="最低价" />——<input class="label" placeholder="最高价"/>
              </div>
            </div> -->
            <div class="item" v-for="tag,index in GoodsPropertieTags" ref="toggleWrap">
              <p class="filter-list-header" @click="toggleNexted(index)">{{tag.linkName}}<samp class="arrow" v-if="index >= eq" :class="{upArrow:index==nextId}"></samp></p>
              <div class="list-item" :class="{spread:  index<eq || index==nextId}">
                <span class="label" v-for="subtag in tag.subs" :class="{active:  checkedTag && checkedTag[index] && checkedTag[index].linkInfo && checkedTag[index].linkInfo.linkTarget==subtag.linkTarget}"  @click="selectTag(index,subtag)">{{subtag.linkName}}</span>
              </div>
            </div>
          </div>
          <div class="buttons">
            <mu-raised-button label="重置" class="reset-button" primary @click="reset"/>
            <mu-raised-button label="确定" class="submit-button" primary @click="filter"/>
          </div>
      </div>
    </mu-popup>
    <mu-toast v-if="toast.toast" :message="toast.messageTip" class="custom-toast" />
  </div>
</template>
<script type="text/javascript">
  import imgs from '@components/image/image';
  import topLink from '@components/topLink/topLink';
  import {mapActions,mapGetters} from 'vuex';
  import empty from '@components/empty/empty';
  export default{
    data(){
      return {
        load:true,
        asc: '',//1表示升序排列，2表示降序排列
        isColligate: false,
        rightPopup: false,
        eq: 2,//默认展示条数
        nextId: null,
        GoodsPropertieTags:[],//18.6.获取商品 属性标签
        checkedTag: [],//选中的商品属性
        goodsList: [],//商品列表
        pageNo: 1,//当前页码
        pageSize: 10,//每次加载条数
        total: 0,//z总数量
        currentPage: 1,//当前页
        lastPageNo:1,//总共页面数量
        loading: false,
        isSavePosition: true,
          scroller: null,
          keyWord:this.$route.query.keyWord || null,
          linkTarget:this.$route.query.linkTarget,
          linkType:this.$route.query.linkType,
          seo:true,//综合
          sorts:[],
          brands:[],
          adver:{},//随机广告
          toast:{
            toast:false,
            messageTip:'',
         },
         isfocu:false,
      }
    },
    computed:{
      ...mapGetters({
        shareGoodsLists: 'shareGoodsLists',
        statePageNo: 'pageNo',
        lastPage: 'lastPage'
      })
    },
    updated () {
      if(!this.$route.meta.savePosition){
        return;
      }
      this.$nextTick(function(){
        this.$refs.listBox.scrollTop = this.$route.meta.savePosition;
      }) 
    },
    created(){
      this.nextId = this.eq;
      this.getGoodsPropertieTag().then(res => {
            this.GoodsPropertieTags = res.tags;
        }).then(res =>{
          
          this.getBrands().then(res => {
            res.unshift({
              linkName:"全部",
              linkType:'8',
              sort:'-1'
            })
            let brandstags={
              linkName:"品牌",
            subs:res
            }
            this.GoodsPropertieTags.unshift(brandstags);
            this.checkedTag = [];
            if(this.GoodsPropertieTags && this.GoodsPropertieTags.length){
                this.GoodsPropertieTags.forEach(item => {
                  let tag = {
                    tagId: item.linkTarget,
                    linkInfo: ""
                  }
                  this.checkedTag.push(tag);
                })
            }
            if(this.linkTarget && this.linkType){
                this.checkedTag[0].linkInfo = {
                  linkTarget:this.linkTarget,
                  linkType:this.linkType
                } 
            }
            //console.log(">>>>",this.checkedTag)
            this.pageGoods();
          })
        })
        
        
        this.randomAdver([1,4]).then(res => {
            this.adver = res[0];
        })

    },
    mounted() {
      
      this.scroller = document.querySelectorAll('.box')[0]
      },
    watch:{

    },
    methods:{
      ...mapActions({
          getGoodsSearchSort: 'getGoodsSearchSort',//获取排序列表
          pageShareGoods: 'pageShareGoods',//分页查询商品数据
          getGoodsPropertieTag: 'getGoodsPropertieTag',//获取搜索页面属性标签
          getBrands:'getBrands',//获取品牌
          randomAdver:'randomAdver',//24.1.随便获取商城N条广告
          savePosition: "savePosition"
      }),
      gotoSunhomeDetail(shareId){
        this.$route.meta.savePosition = this.$refs.listBox.scrollTop;
        this.$router.push({ path: '/main/sunhomedetail?shareId='+shareId});
      },
       // 加载更多
        loadMore() {
          this.loading = true;
          this.$route.meta.savePosition = "";
          if(this.lastPageNo == this.pageNo){
            this.loading = false;
            // this.toast.toast = true;
           //  this.toast.messageTip = '没有更多数据啦~'
           //  setTimeout(() => { this.toast.toast = false }, 1500)
          }else{
            setTimeout(() => {
              this.pageNo ++ ;
              this.pageGoods();
              this.loading = false
           }, 2000)
          }
          
        },
      select(){
        //this.asc='asc';
        this.isColligate=true;
      },
      blurinput(){
        setTimeout(this.isfocu = false,15000)
        
      },
      focusinput(){
        if(this.keyWord != null){
          this.isfocu = true;
        }else{
          this.isfocu = true;
        }
        
      },
      gotoAdverDetail(){
        switch(this.adver.linkType){
          case '1':
            break;
          default:
            break;
        }
      },
      toggleNexted(id){
        if(id < this.eq){
          return;
        }
        if(id==this.nextId){
          this.nextId = null;
          return;
        }
        this.nextId = id;
      },
      //选择商品属性标签
        selectTag(index,item){
          this.checkedTag[index].linkInfo = item;
        },
        //商品分页查询
        pageGoods(){
          let links = [];
          if(this.checkedTag && this.checkedTag.length){
            this.checkedTag.forEach(item => {
              let link = {};
              if(item.linkInfo && item.linkInfo.linkTarget){
                link.linkType = item.linkInfo.linkType;
                link.linkTarget = item.linkInfo.linkTarget;
                links.push(link);
              }
            })
          }
          // //如当前
          // if(this.linkTarget && this.linkType){
          //  links.push({
          //    linkTarget:this.linkTarget,
          //    linkType:this.linkType
          //  })
          // }
          
          let keyWord = this.keyWord;
          let params = {
            links: links,
            keyWord: keyWord,
            sorts: this.sorts
          };


          if(this.$route.meta.savePosition){
            this.pageNo = this.statePageNo;
            this.goodsList = this.shareGoodsLists;
            this.lastPageNo = this.lastPage;
            this.load = false;
            return;
          }
          
          this.pageShareGoods([params,this.pageNo,this.pageSize]).then(res => {
            res.result.forEach(item => {
               this.goodsList.push(item)
            })
            this.lastPageNo = Number(res.lastPageNo);
            this.total = Number(res.totalCount);
            this.currentPage = Number(res.currentPageNo);
            this.load = false;
          })
        },
        scanDetail(storeid,goodid,skuId){
        this.$router.push({
          path: '/main/goodsDetail?goodsId='+ goodid +'&storeId=' + storeid +'&skuId=' + skuId
        })
      },
        reset(){
          this.checkedTag = [];
        },
        seoRanking(){
          if(this.seo){
            this.seo = false;
          }else{
            this.asc = ''
            this.sorts=[];
            this.seo = true;
          }
          this.filter();
        },
        sale(action){
          this.seo = false;
          let sort = {
                sortType: "1",
                sort:action
              }
              this.asc = action;
              this.sorts.push(sort);
              this.filter()
        },
        filter(){
        this.pageNo = 1;
          this.load = true;
          this.isColligate=false;
          this.rightPopup=false
          this.goodsList = [];
          this.pageGoods();
        }
    },
    components:{
      topLink,
      imgs,
      empty
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import 'src/common/sass/mixin.scss';
  .filter-popup{
    width: 72%;
    height: 100% !important;
    .filter-header,.filter-list-header{
      position: relative;
      .arrow{
        height: 0.5rem;
        width: 0.625rem;
        position: absolute;
      }
    }
    .filter-list-header{
      .arrow{
        top: -0.05rem;
        right: 0.375rem;
        @include arrow(#999999, down, 0.25rem, 0.025rem, 0);
        &:after{
          transition: .2s;
        }
        &.upArrow{
          &:after{
            transition: .2s;
            transform: rotate(-45deg);
          }
        }
      }
    }
    .list-item{
      height: 0;
      overflow: hidden;
      transition: .5s;
      &.spread{
        height: auto;
        transition: .5s;
      }
    }
    .filter-header{
      .arrow{
        left: 0;
        top: 0.45rem;
        @include arrow(#999999, right, 0.25rem, 0.025rem, 0);
      }
    }
    .filter-header{
      padding: 0.375rem 0 0.075rem 0;
      position: relative;
      text-align: center;
      >samp{
        @include font-dpr(18px);
        color: #333333;
      }
    }
    .buttons{
      height: 1.15rem;
      font-size: 0;
      .reset-button,.submit-button{
        width: 50%;
        border: none;
        height: 1.15rem;
        color: #fff;
        @include font-dpr(16px);
        border-radius: 0;
        box-shadow: none;
      }
      .reset-button{
        background: #FF910E !important;
      }
      .submit-button{
        background: #E60012;
      }
    }
    .flex-item{
      .item{
        padding: 0.3rem 0 0.05rem 0.25rem;
        @include font-dpr(14px);
        border-bottom: 1px solid #E5E5E5;
        >p{
          padding-bottom: 0.3rem;
          color: #999999;
        }
        .label{
          display: inline-block;
          padding: 0.2rem 0.475rem;
          background: #EEEEEE;
          border-radius: 0.075rem;
          margin: 0 0.25rem 0.25rem 0;
          &.active{
            background: #FFE4E4;
            color: #E60012;
          }
        }
        input{
          width: 2rem;
        }
        input:nth-child(2){
          margin-left: 0.25rem;
        }
      }
    }
  }
  .search-wrap{
    .input-box{
      width: 100%;
      padding: 0.1rem 0;
      background: #fff;
      box-shadow: 0 1px 2px 0 rgba(0,0,0,0.09);
      z-index: 2;
      text-align: center;
      .serarch-input{
        display: inline-block;
        width: 70%;
        height: 0.7rem;
        margin: 0 auto;
        border-radius: 0.675rem;
        @include sInput(#EFEFEF,center,#999999);
        background: url(/static/images/productList_search@3x.png) no-repeat 0.25rem center;
        background-size: 0.45rem;
        background-color: #EFEFEF;
      }
      .search-btn{
        display: inline-block;
        margin-left: 0.25rem;
        @include font-dpr(14px);
        color: #666666;
      }
      .multiple{
          padding-right: 0.35rem;
          background: url(/static/images/ic_screen_condition_3x.png) no-repeat right center;
          background-size: 0.3rem auto;
      }
    }
    .search-condition{
      height: 1.125rem;
      background: #fff;
      font-size: 0;
      box-shadow: 0 1px 2px 0 rgba(0,0,0,0.09);
      z-index: 2;
      .mu-flat-button{
        height: 100%;
        width: 33%;
        .mu-flat-button-label{
          @include font-dpr(16px);
        }
        &.multiple{
          .mu-flat-button-label{
            padding-right: 0.55rem;
            background: url(/static/images/ic_screen_condition_3x.png) no-repeat right center;
            background-size: 0.3rem auto;
          }
        }
        &.sales,&.colligate{
          .mu-flat-button-label{
            display: inline-block;
            padding-right: 0.45rem;
            position: relative;
            &:before{
              @include triangle(up,0.125rem,#A9A9A9);
              right: 0;
              
            }
            &:after{
              @include triangle(down,0.125rem,#A9A9A9);
              right: 0;
            }
          }
        }
        &.activeAsc{
          .mu-flat-button-label{
            color: #E60012;
            &:before{
              border-bottom-color: #E60012;
              bottom: 45%;
            }
            &:after{
              display: none;
            }
          }
        }
        &.primary{
          color: #E60012;
        }
        &.activeDesc{
          .mu-flat-button-label{
            color: #E60012;
            &:before{
              display: none;
            }
            &:after{
              border-top-color: #E60012;
              top: 45%;
            }
          }
        }
      }
    }
    .colligate-select{
      position: fixed;
      top: 2.75rem;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0,0,0,.5);
      .radio{
        height: 2.55rem;
        @include font-dpr(14px);
        .radio-item{
          height: 1.25rem;
          background: #fff;
          padding: 0 0.35rem;
          line-height: 1.25rem;
          border-bottom: 1px solid #E5E5E5;
          &.active{
            color: #DA251D;
            position: relative;
            &:after{
              content: "";
              display: inline-block;
              width: 0.2rem;
              height: 0.375rem;
              border-top: 0.05rem solid #DA251D;
              border-left: 0.05rem solid #DA251D;
              position:absolute;
              right: 0.5rem;
              top: 29%;
              transform: rotate(-135deg);
            }
          }
        }
      }
    }
    .flex-item{
      .bottom {
        margin-bottom: 0.2rem;
        background: #fff;
        .left-advertise {
          width: 50%;
          display: -webkit-inline-box;
          overflow: hidden;
          vertical-align: top;
          >.img {
            padding: 0.25rem;
                width: 100%;
            .image-wrap {
              .img {
                height: 2.95rem;
                overflow: hidden;
              }
            }
          }
          .title {
            text-align: left;
            margin: 0.25rem 0.1rem;
            color: #666666;
          }
          .userName {
            padding: 0.35rem 0.1rem 0.35rem 0.1rem;
            color: #999999;
          }
          .style-box {
            padding: 0 0.1rem 0 0.1rem;
            font-size: 0;
            >span {
              display: inline-block;
              vertical-align: middle;
              @include font-dpr(12px);
              &.style {
                /*width: 67%;*/
                color: #333333;
              }
              &.price {
                max-width: 33%;
                color: #E60012;
                text-align: right;
                white-space: nowrap;
              }
            }
          }
        }
        .right-advertise {
          .advertise-box {
            overflow-x: auto;
            >div.adver-box {
              white-space: nowrap;
              -webkit-overflow-scrolling: touch;
            }
          }
          .img-box {
            display: inline-block;
            width: 2.7rem;
            margin-right: 0.05rem;
            white-space: normal;
            .image-wrap {
              .img {
                height: 2.7rem;
                text-align: center;
                &:before {
                  content: "";
                  display: inline-block;
                  height: 100%;
                  vertical-align: middle;
                }
                img {
                  display: inline-block;
              /* width: 1.05rem;
              height: 2.25rem; */
              vertical-align: middle;
            }
          }
        }
        .title {
          margin: 0.125rem 0.125rem 0.2rem 0.125rem;
          color: #666666;
          @include font-dpr(10px);
        }
      }
      .link-phone,
      .phoneNum {
        display: block;
        text-align: center;
        @include font-dpr(14px);
        color: #333333;
      }
      .link-phone {
        padding: 0.25rem 0;
        text-indent: 0.5rem;
        background: url(/static/images/ic_service_3x.png) no-repeat 30% center;
        background-size: 0.4rem auto;
      }
      .phoneNum {
        color: #F5A623;
        margin-bottom: 0.3rem;
      }
    }
  }
      .banner-img{
        height: auto;
        overflow: hidden;
      }
      .none-goods{
        text-align: center;
          line-height: 1rem;
          color: #ccc;
      }
      .product-lists{
        font-size: 0;
        padding: 0.05rem 0.05rem;
        
        .product-list{
          display: inline-block;
          vertical-align: top;
          width: 50%;
          .img-box{
            margin: 0.1rem 0.1rem;
            background: #fff;
          }
        }
        .product-list:nth-child(2n+1){
          .img-box{
            margin:0.1rem 0.05rem 0 0.1rem;
          }
        }
        .product-list:nth-child(2n){
          .img-box{
            margin:0.1rem 0.1rem 0 0.05rem;
          }
        }
      }
    }
  }
  /*加载框*/

  .mu-infinite-scroll {
    margin-top: 0.2rem;
    /*height: 0.6rem;*/
    .mu-circle-wrapper.active {
      height: 0.6rem !important;
      width: 0.6rem !important;
    }
    .mu-circle-spinner .mu-circle-gap-patch {
      /*border-color: #E60012;*/
      background: url("/static/images/refresh@3x.png") no-repeat center;
      background-size: 0.6rem;
      left: 0%;
      width: 100%;
    }
    .mu-circle-wrapper .left,
    .mu-circle-wrapper .right {
      display: none;
    }
    .mu-infinite-scroll-text {
      margin-left: 0px;
      @include font-dpr(14px);
      color: #E60012;
    }
  }
</style>


// WEBPACK FOOTER //
// sunhomelist.vue?7f90d694